// extracted by mini-css-extract-plugin
export default {"button":"OtherVideosButton_button__a9cWx","buttonText":"OtherVideosButton_buttonText__a-mTv"};